import ModelRelationshipProxy from '/@/modules/core/app/models/relationships/ModelRelationshipProxy';
import Logger from '/@/modules/core/app/helpers/Logger';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ModelType } from '@/modules/core/app/constants/ModelType';

/**
 * @deprecated
 */
export class ModelRelationshipFactory {
  /**
   * @returns {BaseEntityModel}
   */
  static build<T extends BaseModel>(modelName: ModelType | string, model: Partial<T>): Partial<T> {
    try {
      return ModelRelationshipProxy.proxy.map(modelName, model);
    } catch (e) {
      // @ts-ignore
      Logger.error(e.message);
    }

    return model;
  }
}
